<template>
    <div>
        <TopBar
            activeTab="Profile"
            :lbl="lbl"
            :profile="profile"
            :isLogin="isLogin"
        ></TopBar>
        <div class="container">
            <h3 class="text-center mt-2">AddressList</h3>

            <div>
                <button class="btn btn-dark" @click="clickAddTaxAddress()">
                    Add new Tax Address
                </button>
                &nbsp;
                <button
                    class="btn btn-warning"
                    @click="clickListTaxAddressModal()"
                >
                    Modal list tax address
                </button>
            </div>
            <TaxAddressList
                ref="tax-address-list"
                @onEditAddress="clickEditAddress($event)"
                @onDeleteAddress="clickDeleteAddress($event)"
            ></TaxAddressList>
        </div>

        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import Account from "@/helper/AccountHelper.js";
//component
import TopBar from "@/components/Layout/TopBar/TopBar.vue";
import TaxAddressList from "../component/TaxAddressList.vue";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import AccountMixin from "@/mixin/AccountMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
//service
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";

export default {
    name: "TaxAddress",
    mixins: [LocaleMixin, AccountMixin, ModalMixin],
    components: {
        TopBar,
        TaxAddressList
    },
    methods: {
        //#region mixin function
        onSetupModalCompleted: function() {
            this.initialTaxAddressModal();
        },
        //#endregion mixin function

        reloadAddressList: function() {
            this.$refs["tax-address-list"].getAddressList();
        },

        clickAddTaxAddress: function() {
            this.addTaxAddressModal.show();
            this.addTaxAddressModal.onAddSuccess(() => {
                this.reloadAddressList();
            });
        },
        clickEditAddress: function(address) {
            this.editTaxAddressModal.setAddress(address).show();
            this.editTaxAddressModal.onEditSuccess(() => {
                this.reloadAddressList();
            });
        },
        clickDeleteAddress: function(address) {
            this.confirmModal
                .clearModal()
                .setMsg("ต้องการลบ Tax Address ?")
                .show();
            this.confirmModal.onClickOk(() => {
                this.apiDeleteTaxAddress(address);
            });
        },

        apiDeleteTaxAddress: function(address) {
            let token = Account.getToken();
            this.loadingModal.show();

            BzbsAddressList.apiDeleteTaxAddress(
                token,
                address.rowKey
            ).subscribe(
                () => {
                    this.loadingModal.hide();
                    this.reloadAddressList();
                },
                err => {
                    this.loadingModal.hide();
                    this.errorResponse(err);
                }
            );
        },

        clickListTaxAddressModal: function() {
            this.listTaxAddressModal.show();
        }
    }
};
</script>
<style lang="scss" scoped></style>
